import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import "./styles.css";

const storageKey = "nv-theme";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container not found");
}

if (typeof window !== "undefined") {
  const stored = window.localStorage.getItem(storageKey);
  const resolvedTheme =
    stored === "light" || stored === "dark"
      ? stored
      : window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";

  document.documentElement.dataset.themeSource = resolvedTheme;
  document.documentElement.dataset.theme = resolvedTheme;
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
